import React, { useEffect, useMemo } from "react";
import useState from "react-usestateref";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import { Helmet } from "react-helmet";
import Footer from "../FooterNew";
import { choose_Blog_page_Details } from "../../config/apiCall";
import { get_Catagory } from "../../config/apiCall";
import { choose_Catagory } from "../../config/apiCall";
import httpService from "../../config/httpCall";
import { search_list } from "../../config/apiCall";
import { blog_contact_details } from "../../config/apiCall";
import { toastAlert } from "../../config/toastAlert";
import PhoneInput from "react-phone-input-2";
import { related_blog } from "../../config/apiCall";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import countryList from "react-select-country-list";
import { useLocation } from "react-router-dom";
import "./BlogNew.css";

import {
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  PinterestIcon,
  LinkedinIcon,
  TelegramIcon,
  XIcon,
} from "react-share";
import NewFooter from "../landing/NewFooter";
import NewHead from "../landing/NewHead";

function AIcryptoBlog() {
  const initialFormValue = {
    name: "",
    email: "",
    phoneNumber: "",
    country: "",
    socialContact: "",
    message: "",
  };

  const [blog, setBlog] = useState([]);
  const [catagory, setCatagory] = useState([]);
  const [chooseCatagory, setChooseCatagory] = useState([]);
  const [search, setsearch] = useState(1);
  const [searchField, setSearchField] = useState("false");
  const [count, setCount] = useState(5);
  const [formValue, setFormValue] = useState(initialFormValue);
  const { name, email, phoneNumber, country, socialContact, message } =
    formValue;
  const [mobileValue, setMobileValue] = useState();
  const [vallidationNameErr, setVallidationNameErr] = useState(false);
  const [getblog, setgetblog, getblogref] = useState();
  const [vallidationEmailErr, setVallidationEmailErr] = useState(false);
  const [vallidationPhoneNumberErr, setVallidationPhoneNumberErr] =
    useState(false);
  const [vallidationcountryErr, setVallidationcountryErr] = useState(false);
  const [vallidationmessageErr, setVallidationmessageErr] = useState(false);
  const [vallidationSocialContact, setVallidationSocialContact] =
    useState(false);
  const [vallidation, setVallidation] = useState(false);
  const [relatedBlog, setRelatedBlog] = useState([]);

  var urls = window.location.href;
  var urlsplit = urls.split("/").at(3);
  const location = useLocation();
  const canonicalUrl = `https://www.beleaftechnologies.com${location.pathname}`;
  useEffect(() => {
    // choose_Blog_page(0);
    // get_Catagory_Details(0);
    // if (getblogref.current == false) {
    //   get_Catagory_Details(0);
    // }
  }, [0]);
  const get_Catagory_Details = async (view) => {
    setpageloader(true);

    var data = {
      apiUrl: httpService.get_Catagory,
    };
    var resp = await get_Catagory(data);
    setCatagory(resp.Message.get_Catagory);
    setpageloader(false);
  };
  let navigate = useNavigate();
  const [pageloader, setpageloader] = useState("false");

  const choose_Blog_page = async () => {
    setpageloader(true);
    var obj = {
      url: urlsplit,
    };
    var data = {
      apiUrl: httpService.choose_Blog_page_Details,
      payload: obj,
    };
    var resp = await choose_Blog_page_Details(data);
    setpageloader(false);

    if (resp.status == false) {
      setgetblog(false);
      navigate("*");
    } else {
      setgetblog(true);
      setBlog(resp.Message.findblog);
      setCount(resp.Message.count);
      var catagaryobj = {
        catagory: resp.Message.findblog.catagaryUrl,
      };
      var data = {
        apiUrl: httpService.related_blog,
        payload: catagaryobj,
      };
      var resp = await related_blog(data);
      setRelatedBlog(resp.Message.relatedbloglist);
    }
  };
  const choose = async (e) => {
    var choosecatory = e.target.innerHTML;
    var obj = {
      choosecatory,
    };
    var data = {
      apiUrl: httpService.choose_Catagory,
      payload: obj,
    };
    var resp = await choose_Catagory(data);
    setChooseCatagory(resp.Message.choosecatagory);
  };
  const searcharea = async (data) => {
    var obj = {
      search: data,
    };
    var data = {
      apiUrl: httpService.search_list,
      payload: obj,
    };
    var resp = await search_list(data);
    setSearchField(true);

    setCatagory(resp.Message.findblog);
  };
  const handleChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      let formData = { ...formValue, ...{ [name]: value } };
      setFormValue(formData);
    } catch (error) {}
  };
  const vallidate = async () => {
    try {
      const errors = {};
      if (formValue.name == "") {
        setVallidationNameErr(true);
        errors.name = "Must Enter Your Name";
      } else {
        setVallidationNameErr(false);
      }
      if (formValue.email == "") {
        setVallidationEmailErr(true);
        errors.email = "Must Enter Your Email";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formValue.email)
      ) {
        setVallidationEmailErr(true);
        errors.email = "Invalid Email";
      } else {
        setVallidationEmailErr(false);
      }
      if (formValue.phoneNumber == "") {
        setVallidationPhoneNumberErr(true);
        errors.phoneNumber = "Must Enter Your phoneNumber";
      } else {
        setVallidationPhoneNumberErr(false);
      }
      if (formValue.country == "") {
        setVallidationcountryErr(true);
        errors.country = "Must Enter Your country";
      } else {
        setVallidationcountryErr(false);
      }
      if (formValue.message == "") {
        setVallidationmessageErr(true);
        errors.message = "Must Enter Your country";
      } else {
        setVallidationmessageErr(false);
      }
      if (formValue.socialContact == "") {
        setVallidationSocialContact(true);
        errors.socialContact = "Must Enter Your socialContact";
      } else {
        setVallidationSocialContact(false);
      }
      setVallidation(errors);
    } catch {}
  };

  const [value, setValue] = useState("");
  const options = useMemo(() => countryList().getData(), []);

  const changeHandler = (value) => {
    setValue(value);
    formValue.country = value.label;
  };

  const submit = async () => {
    try {
      formValue.phoneNumber = mobileValue;
      vallidate(formValue);
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formValue.email)) {
        vallidate(formValue);
      } else {
        if (
          formValue.name != "" &&
          formValue.email != "" &&
          formValue.phoneNumber != "" &&
          formValue.country != "" &&
          formValue.message != ""
          // formValue.socialContact != ""/
        ) {
          var data = {
            apiUrl: httpService.blog_contact_details,
            payload: formValue,
          };
          var resp = await blog_contact_details(data);
          toastAlert("success", resp.Message);
        } else {
        }
      }
    } catch (error) {
      console.log(error, "----------");
    }
  };
  const [sharestatus, setsharestatus] = useState(true);
  const share = () => {
    if (sharestatus == true) {
      setsharestatus(false);
    } else {
      setsharestatus(true);
    }
  };
  return (
    <>
      {/* {pageloader == true ? (
        <div className="nodata">
          <img
            className=" mx-auto d-block"
            src={require("../../image/load2.gif")}
          ></img>
        </div>
      ) : getblogref.current == true ? ( */}
      <div className="blog_header">
        <header className="newpage nft_new_page  p-0">
          <Helmet>
            <title>AI Crypto Trading Platform</title>

            <meta name="title" content="How to Develop an AI Crypto Trading Platform" />
            <meta name="description" content="Develop your ai crypto trading platform with beleaf technologies with cutting edge features. Get free consultation" />

            <meta property="og:title" content="AI Crypto Trading Platform" />
            <meta property="og:site_name" content="Beleaf Technologies" />

            <link
              rel="canonical"
              href="https://www.beleaftechnologies.com/how-to-develop-an-ai-crypto-trading-platform"
            />
          </Helmet>
          {/* <Header /> */}
          <NewHead />
        </header>
        <main className="pading_dsds">
          <section className="blog_heading_section">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="links_blog">
                    <div>
                      <h3>Blogs</h3>
                    </div>
                    <div>
                      <a href="/">Home</a>
                      <span>
                        <i className="bi bi-caret-right"></i>
                      </span>
                      <a href="/blog_details" className="">
                        Blogs
                      </a>
                      <span>
                        <i className="bi bi-caret-right"></i>
                      </span>
                      <a href="/" className="current">
                        How to Develop an AI Crypto Trading Platform{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="container">
            <div className="row">
              <div className="col-lg-9">
                <div className="image_conainer">
                  <img src={require("../../image/cryptoexchange/cry.webp")} />
                </div>
                <div className="blog_header">
                  <h1>How to Develop an AI Crypto Trading Platform</h1>
                  <div className="content_blog p-0">
                    <div className="by_conte">
                      <p>
                        by<strong>Admin </strong>
                      </p>
                      <span>6th January 2025</span>
                    </div>

                    <div className="icon_secton">
                      <span>
                        <i className="bi bi-eye"></i>
                        205
                      </span>
                    </div>
                  </div>
                </div>
                <div className="content_blog_text">
                  {/* <p dangerouslySetInnerHTML={{ __html: blog.content }}></p> */}
                  <p>
                    <span>
                      The fusion of artificial intelligence (AI) and
                      cryptocurrency trading has opened new frontiers for
                      innovation and efficiency. Developing an AI-driven crypto
                      trading platform requires a blend of advanced
                      technologies, robust security, and user-friendly
                      interfaces. This guide provides a detailed roadmap for
                      creating an AI crypto trading platform that caters to the
                      needs of traders while standing out in a competitive
                      market.
                    </span>
                  </p>
                  <h4>
                    <span>
                      <strong>Step 1: Define Your Vision and Objectives</strong>
                    </span>
                  </h4>
                  <p>
                    <span>
                      Start by outlining the purpose and goals of your AI crypto
                      trading platform. Consider:
                    </span>
                  </p>
                  <ul typeof="disclosure-closed">
                    <li>
                      <span>
                        <strong>Target Audience:</strong>
                        Are you catering to beginner traders, experienced
                        investors, or institutional clients?
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Key Features:</strong>
                        Will your platform focus on algorithmic trading,
                        portfolio management, or market analytics?
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Revenue Model:</strong>
                        Choose between subscription fees, transaction fees, or
                        premium services.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Step 2: Research and Competitor Analysis</strong>
                    </span>
                  </h4>
                  <p>
                    <span>
                      Analyze existing AI crypto trading platforms to identify:
                    </span>
                  </p>
                  <ul typeof="disclosure-closed">
                    <li>
                      <span>Strengths and weaknesses of competitors.</span>
                    </li>
                    <li>
                      <span>Market gaps your platform can address.</span>
                    </li>
                    <li>
                      <span>
                        Emerging trends in AI and crypto trading technologies.
                      </span>
                    </li>
                  </ul>
                  <p>
                    <span>
                      Use insights from your research to create a unique value
                      proposition.
                    </span>
                  </p>
                  <h4>
                    <span>
                      <strong>Step 3: Choose the Right Technology Stack</strong>
                    </span>
                  </h4>
                  <p>
                    <span>
                      A robust technology stack is crucial for the performance
                      and reliability of your platform. Key components
                      include:Use insights from your research to create a unique
                      value proposition.
                    </span>
                  </p>
                  <h4>
                    <span>
                      <strong>Backend Development</strong>
                    </span>
                  </h4>
                  <ul typeof="disclosure-closed">
                    <li>
                      <span>
                        <strong>Programming Languages:</strong>
                        Are you catering to beginner traders, experienced
                        investors, or institutional clients? Python, JavaScript,
                        or Rust for flexibility and performance.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Frameworks:</strong>
                        Django, Flask, or Node.js for efficient development.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Database:</strong>
                        Use NoSQL databases like MongoDB for scalability and
                        performance.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Frontend Development</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        <strong>Frameworks:</strong> React, Angular, or Vue.js
                        for a responsive and intuitive user interface.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>APIs:</strong> Integrate third-party APIs for
                        real-time data, such as price feeds and exchange APIs.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>AI and Machine Learning Tools</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Using TensorFlow, PyTorch, or Scikit-learn to develop
                        and train AI models.
                      </span>
                    </li>
                    <li>
                      <span>
                        Natural Language Processing (NLP) for sentiment
                        analysis.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Blockchain Integration:</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Smart contracts for automated trading on decentralized
                        exchanges.
                      </span>
                    </li>
                    <li>
                      <span>
                        Wallet integration for secure storage and transactions.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Step 4: Develop Core Features</strong>
                    </span>
                    <br />
                    <span>
                      <strong>1. AI-Powered Trading Bots</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Automate trading strategies based on predefined rules or
                        AI-driven insights.
                      </span>
                    </li>
                    <li>
                      <span>
                        Use reinforcement learning to improve trading algorithms
                        over time.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>2. Predictive Analytics</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Implement AI models to analyze historical data and
                        forecast market trends.
                      </span>
                    </li>
                    <li>
                      <span>Provide traders with actionable insights.</span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>3. Sentiment Analysis</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Use NLP to assess market sentiment from news, social
                        media, and forums.
                      </span>
                    </li>
                    <li>
                      <span>
                        Incorporate sentiment scores into trading strategies.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>4. Risk Management Tools</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Offer tools to set stop-loss, take-profit levels, and
                        manage portfolio risk.
                      </span>
                    </li>
                    <li>
                      <span>Use AI to suggest optimal risk-reward ratios.</span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>5. Customizable Dashboards</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Allow users to personalize their trading interfaces with
                        widgets and analytics.
                      </span>
                    </li>
                    <li>
                      <span>
                        Provide real-time performance metrics and reports.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>6. Multi-Exchange Integration</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Connect to multiple crypto exchanges via APIs for
                        diversified trading options.
                      </span>
                    </li>
                    <li>
                      <span>
                        Ensure compatibility with both centralized and
                        decentralized exchanges.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Step 5: Focus on Security and Compliance</strong>
                    </span>
                  </h4>
                  <h4>
                    <span>
                      <strong>Security Measures:</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        <strong>Data Encryption:</strong> Use advanced
                        encryption protocols to protect sensitive data.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Two-Factor Authentication (2FA):</strong> Ensure
                        secure user access.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Penetration Testing:</strong> Regularly test for
                        vulnerabilities to mitigate risks.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Regulatory Compliance:</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Ensure the implementation of Anti-Money Laundering (AML)
                        and Know Your Customer (KYC) procedures.
                      </span>
                    </li>
                    <li>
                      <span>
                        Stay updated on regional crypto regulations to avoid
                        legal issues.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Step 6: Develop and Train AI Models</strong>
                    </span>
                  </h4>
                  <h4>
                    <span>
                      <strong>1. Data Collection</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Gather historical and real-time market data from
                        reliable sources.
                      </span>
                    </li>
                    <li>
                      <span>
                        Include diverse datasets for training robust AI models.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>2. Model Development</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Use supervised and unsupervised learning techniques for
                        predictive analytics.
                      </span>
                    </li>
                    <li>
                      <span>
                        Incorporate reinforcement learning for dynamic trading
                        strategies.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>3. Testing and Optimization</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Validate AI models using backtesting on historical data.
                      </span>
                    </li>
                    <li>
                      <span>
                        Optimize algorithms for speed, accuracy, and
                        adaptability.
                      </span>
                      &nbsp;
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Step 7: Build a Scalable Infrastructure</strong>
                    </span>
                  </h4>
                  <h4>
                    <span>
                      <strong>Cloud Hosting</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Choose cloud providers like AWS, Google Cloud, or Azure
                        for scalability and reliability.
                      </span>
                    </li>
                    <li>
                      <span>
                        Use containerization tools like Docker and Kubernetes
                        for efficient resource management.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Load Balancing</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Implement load balancers to handle high traffic during
                        market surges.
                      </span>
                    </li>
                    <li>
                      <span>
                        Ensure consistent platform performance under heavy
                        usage.
                      </span>
                      &nbsp;
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>
                        Step 8: User Experience (UX) and Interface Design
                      </strong>
                    </span>
                  </h4>
                  <h4>
                    <span>
                      <strong>1. Intuitive Navigation</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Design an interface that simplifies trading for all
                        experience levels.
                      </span>
                    </li>
                    <li>
                      <span>
                        Use user-friendly charts and tools for analysis.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>2. Mobile App Development</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Offer a responsive mobile application for on-the-go
                        trading.
                      </span>
                    </li>
                    <li>
                      <span>
                        Include push notifications for price alerts and updates.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>3. Localization</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Provide multi-language support to attract a global
                        audience.
                      </span>
                      &nbsp;
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Step 9: Test the Platform</strong>
                    </span>
                  </h4>
                  <p>
                    <span>
                      Conduct thorough testing to ensure platform stability and
                      reliability:
                    </span>
                  </p>
                  <ul>
                    <li>
                      <span>
                        <strong>Functional Testing:</strong> Verify all features
                        work as intended.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Security Testing:</strong> Identify and address
                        vulnerabilities.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>Performance Testing:</strong> Ensure the
                        platform performs well under stress.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong>User Acceptance Testing (UAT):</strong> Gather
                        feedback from beta testers to refine the platform.
                      </span>
                      &nbsp;
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Step 10: Launch and Market the Platform</strong>
                    </span>
                  </h4>
                  <h4>
                    <span>
                      <strong>Pre-Launch</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Create hype with teasers and pre-launch offers.
                      </span>
                    </li>
                    <li>
                      <span>
                        Partner with crypto influencers for promotions.
                      </span>
                    </li>
                  </ul>
                  <h4>
                    <span>
                      <strong>Post-Launch</strong>
                    </span>
                  </h4>
                  <ul>
                    <li>
                      <span>
                        Offer introductory discounts or bonuses to attract early
                        users.
                      </span>
                    </li>
                    <li>
                      <span>
                        Offer round-the-clock customer support to assist with
                        user inquiries..
                      </span>
                    </li>
                  </ul>
                  <h3>
                    <span>
                      <strong>Conclusion</strong>
                    </span>
                  </h3>
                  <p>
                    <span>Developing an </span>
                    <a href="https://www.beleaftechnologies.com/cryptocurrency-exchange-development-company">
                      <span>AI crypto trading platform</span>
                    </a>
                    <span>
                      {" "}
                      requires meticulous planning, advanced technologies, and a
                      user-centric approach. By incorporating AI-driven tools,
                      robust security, and a seamless user experience, you can
                      create a platform that redefines crypto trading. Stay
                      ahead of the curve by embracing emerging trends and
                      continually innovating to meet the dynamic needs of the
                      market.
                    </span>
                    <br />
                    &nbsp;
                  </p>
                </div>
                <div className="share_section justify-content-center">
                  {sharestatus == true ? (
                    <Button onClick={share}>
                      <i className="bi bi-share"></i>Share
                    </Button>
                  ) : (
                    <div className="d-flex">
                      <div className="link_section AlignD" onClick={share}>
                        <a>
                          <img
                            className="imageadjust"
                            src={require("../../image/copy.png")}
                          ></img>
                        </a>
                      </div>

                      <div className="link_section AlignD">
                        <a>
                          <FacebookShareButton
                            url={urls}
                            quote={"Dummy text!"}
                            hashtag="#muo"
                          >
                            <FacebookIcon size={32} round />
                          </FacebookShareButton>
                        </a>
                      </div>

                      <div className="link_section AlignD">
                        {/* <a>
                            <TwitterShareButton
                              url={urls}
                              quote={"Dummy text!"}
                              hashtag="#muo"
                            >
                              <TwitterIcon size={32} round />
                            </TwitterShareButton>
                          </a> */}
                        <a>
                          <TwitterShareButton
                            url={urls}
                            quote={"Dummy text!"}
                            hashtag="#muo"
                          >
                            <XIcon size={32} round />
                          </TwitterShareButton>
                        </a>
                      </div>
                      <div className="link_section  AlignD">
                        <a>
                          <WhatsappShareButton
                            url={urls}
                            quote={"Dummy text!"}
                            hashtag="#muo"
                          >
                            <WhatsappIcon size={32} round />
                          </WhatsappShareButton>
                        </a>
                      </div>
                      {/* <div className="link_section AlignD">
                          <a>
                            <PinterestShareButton
                              url={urls}
                              quote={"Dummy text!"}
                              hashtag="#muo"
                            >
                              <PinterestIcon size={32} round />
                            </PinterestShareButton>
                          </a>
                        </div> */}
                      <div className="link_section AlignD">
                        <a>
                          <LinkedinShareButton
                            url={urls}
                            quote={"Dummy text!"}
                            hashtag="#muo"
                          >
                            <LinkedinIcon size={32} round />
                          </LinkedinShareButton>
                        </a>
                      </div>
                      <div className="link_section AlignD">
                        <a>
                          <TelegramShareButton
                            url={urls}
                            quote={"Dummy text!"}
                            hashtag="#muo"
                          >
                            <TelegramIcon size={32} round />
                          </TelegramShareButton>
                        </a>
                      </div>
                      <div className="link_section AlignD" onClick={share}>
                        <a>
                          {/* <img
                              className="imageadjust"
                              src={require("../image/closeicon.png")}
                            ></img> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 32 32"
                            id="Close"
                            className="imageadjust"
                          >
                            <path
                              d="M17 2C8.716 2 2 8.716 2 17s6.716 15 15 15 15-6.716 15-15S25.284 2 17 2zm6.95 9.464-5.574 5.574 4.932 5.498a1 1 0 0 1-1.414 1.414l-4.932-5.498-5.498 5.498a1 1 0 0 1-1.414-1.414l5.574-5.574-4.932-5.498a1 1 0 0 1 1.414-1.414l4.932 5.498 5.498-5.498a1 1 0 0 1 1.414 1.414z"
                              fill="#ff0900"
                              className="color000000 svgShape"
                            ></path>
                          </svg>
                        </a>
                      </div>
                    </div>
                  )}

                  {/* <div className="footer_menyu_sss"> */}

                  <div></div>
                </div>
                <div className="related_post">
                  <h3>Related Posts</h3>

                  <div className="row">
                    {/* {relatedBlog && relatedBlog.length > 0
                      ? relatedBlog.map((item, i) => {
                          return (
                            <div className="col-lg-4">
                              <div className="blog_card">
                                <div className="blog_img">
                                  <img src={item.image} />
                                </div>
                                <div className="conyente_blog">
                                  <h4>{item.title}</h4>
                                  <a href={`/${item.slug}`}>{item.category}</a>
                                </div>
                                <div className="footer11">
                                  <a href={`/${item.slug}`} target="_blank">
                                    Read more <i className="bi bi-caret-right "></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : "Not Related Post Uptain"} */}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form_search">
                  <input
                    type="text"
                    placeholder="search"
                    onChange={(e) => searcharea(e.target.value)}
                  />
                  {/* <i className="bi bi-search search"  onClick={() => searcharea()}></i> */}
                </div>
                <div className="categorieded">
                  <h3>Categories</h3>
                  {/* {searchField == false ? (
                    <>
                      {catagory.length > 0 ? (
                        catagory.map((item, i) => {
                          return (
                            <ul>
                              <li>
                                <a
                                  onClick={choose}
                                  target="_blank"
                                  href={`/catogary/${item.categoryurl}`}
                                >
                                  {item.categoryname}
                                </a>
                              </li>
                            </ul>
                          );
                        })
                      ) : (
                        <ul>
                          <li>No Category found</li>
                        </ul>
                      )}
                    </>
                  ) : (
                    <>
                      {catagory.length > 0 ? (
                        catagory.map((item, i) => {
                          return (
                            <ul>
                              <li>
                                <a
                                  onClick={choose}
                                  target="_blank"
                                  href={`/catogary/${item.categoryurl}`}
                                >
                                  {item.categoryname}
                                </a>
                              </li>
                            </ul>
                          );
                        })
                      ) : (
                        <ul>
                          <li>No Category found</li>
                        </ul>
                      )}
                    </>
                  )} */}
                </div>
                {/* <div className="categorieded">
                <h3>Recent Posts</h3>
                <ul>
                  <li>
                    <a href="">
                      <i className="bi bi-pencil-square"></i> All
                    </a>
                  </li>
                  <li>
                    <a href="">
                      {" "}
                      <i className="bi bi-pencil-square"></i>Clients
                    </a>
                  </li>

                  <li>
                    <a href="">
                      {" "}
                      <i className="bi bi-pencil-square"></i>Design
                    </a>
                  </li>

                  <li>
                    <a href="">
                      {" "}
                      <i className="bi bi-pencil-square"></i> News
                    </a>
                  </li>
                </ul>
              </div> */}
                <div className="contect_form_bloh border_radie">
                  <h4>Contact Us</h4>
                  <form>
                    <div className="form-group">
                      <input
                        type="name"
                        className="form-control"
                        id="name"
                        placeholder="Name"
                        min={3}
                        max={25}
                        name="name"
                        onChange={handleChange}
                      />
                      {vallidationNameErr && vallidationNameErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {vallidation.name}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Email Address"
                        name="email"
                        value={email}
                        onChange={handleChange}
                      />
                    </div>
                    {vallidationEmailErr && vallidationEmailErr === true ? (
                      <span className="text-danger"> {vallidation.email} </span>
                    ) : (
                      ""
                    )}
                    <div className="form-group">
                      {/* <input
                      type="phoneNumber"
                      className="form-control"
                      id="phoneNumber"
                      placeholder="Phone Number"
                      name="phoneNumber"
                      value={phoneNumber}
                      onChange={handleChange}
                    /> */}
                      <PhoneInput
                        country={"us"}
                        value={mobileValue}
                        onChange={setMobileValue}
                      />
                    </div>
                    {vallidationPhoneNumberErr &&
                    vallidationPhoneNumberErr === true ? (
                      <span className="text-danger">
                        {" "}
                        {vallidation.phoneNumber}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                    <div className="form-group">
                      <Select
                        placeholder=" select country "
                        options={options}
                        value={value}
                        onChange={changeHandler}
                      />
                    </div>
                    {vallidationcountryErr && vallidationcountryErr === true ? (
                      <span className="text-danger">
                        {" "}
                        {vallidation.country}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                    {/* <div className="form-group">
                        <input
                          type="socialcontact"
                          className="form-control"
                          id="socialcontact"
                          min={3}
                          max={25}
                          placeholder="Whatsapp/telegram/skype"
                          name="socialContact"
                          value={socialContact}
                          onChange={handleChange}
                        />
                      </div>
                      {vallidationSocialContact &&
                      vallidationSocialContact === true ? (
                        <span className="text-danger">
                          {" "}
                          {vallidation.socialContact}{" "}
                        </span>
                      ) : (
                        ""
                      )} */}

                    <div className="form-group">
                      <input
                        type="message"
                        className="form-control"
                        id="message"
                        placeholder="Message"
                        name="message"
                        value={message}
                        min={3}
                        max={50}
                        onChange={handleChange}
                      />
                    </div>
                    {vallidationmessageErr && vallidationmessageErr === true ? (
                      <span className="text-danger">
                        {" "}
                        {vallidation.message}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                    <div className="submitbutton">
                      <Button onClick={submit}>Submit</Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>

        {/* <Footer /> */}
        <NewFooter />
      </div>
      {/* ) : (
        ""
      )} */}
    </>
  );
}

export default AIcryptoBlog;
